import React from 'react';

import Grid from '@material-ui/core/Grid';

import { useLoginStyles } from 'consts/styles/Login';

const Copyright = () => {
  const classes = useLoginStyles();
  return (
    <Grid container>
      <Grid className={`${classes.Login}__copyright`} item xs={12}>
        {/* {'Copyright © '}
        <img
          alt="hawk-e logo"
          className={`${classes.Login}__copyright__logo`}
          src="/backgroundImage/copyright_logo.png"
        /> */}
        {new Date().getFullYear()}
      </Grid>
    </Grid>
  );
};

export default Copyright;
